import React from "react";
import { COMPONENT_DATA_LOCAL_KEY } from "features/MappingEditor/consts";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";
import { useNavigate, useParams } from "react-router";
import { ROUTES_ENUM } from "routes/consts";
import { searchStore } from "features/ProductSearch/SearchStore";
import { ProductActionMode } from "utils";

const useComponentActions = () => {
  const navigate = useNavigate();
  const { ifc_id } = useParams();

  const editComponent = async (id?: string | null, isDetails?: boolean) => {
    if (!id) return;
    await searchStore.getComponentDetails(id, ifc_id);
    const pathname = saveStateAndGetPath();
    navigate(`${pathname}/${ROUTES_ENUM.COMPONENT_EDITOR}`, {
      state: {
        id: id,
        compliant: false,
        mode: ProductActionMode.Edit,
        isDetails: isDetails,
      },
    });
  };

  const duplicateComponent = async (
    id?: string | null,
    isDetails?: boolean
  ) => {
    if (!id) return;
    await searchStore.getComponentDetails(id, ifc_id);
    const pathname = saveStateAndGetPath();
    navigate(`${pathname}/${ROUTES_ENUM.COMPONENT_EDITOR}`, {
      state: {
        id: id,
        compliant: false,
        mode: ProductActionMode.Duplicate,
        isDetails: isDetails,
      },
    });
  };

  function saveStateAndGetPath() {
    if (COEStore.openedSearchInCE) {
      localStorage.setItem(
        COMPONENT_DATA_LOCAL_KEY,
        JSON.stringify({
          data: COEStore.data,
        })
      );
    }
    const pathname = location.pathname
      .replace("/component-editor", "")
      .replace(/\/+$/, "");
    return pathname;
  }

  return { editComponent, duplicateComponent, saveStateAndGetPath };
};

export default useComponentActions;
